// removed by extract-text-webpack-plugin
module.exports = {"header":"header","content":"content","content-inner-alma":"content-inner-alma","logo":"logo","logo_text":"logo_text","navbar":"navbar"};


//////////////////
// WEBPACK FOOTER
// ./client/styling/cnino.css
// module id = 166
// module chunks = 0